import React from "react";
import styled from "styled-components";
import Loader from 'react-loader-spinner';
import Text from "antd/lib/typography/Text";

const StyledLoading = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
width: 100vw;
height: 100vh;
`;

const FlexColumn = styled.div`
display: flex;
align-items: center;
`;

export default function ComponentLoading() {
  return (
    <StyledLoading>
      <Loader type="RevolvingDot" color="#0044e0" height={100} width={100} />
    </StyledLoading>
  );
}
